import { Box, Button, Loading } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface SerialSequenceLoadingModalProps {
  title: string
  onClose: () => void
}

export const SerialSequenceLoadingModal = ({ title, onClose }: SerialSequenceLoadingModalProps) => {
  return (
    <Modal
      illustration="input-field"
      title={title}
      description={i18n.t('common.loading')}
      onClose={onClose}
      footer={
        <Button type="secondary" onClick={onClose}>
          {i18n.t('common.cancel')}
        </Button>
      }
    >
      <Box flexDirection="column" alignItems="center" justifyContent="center">
        <Loading />
      </Box>
    </Modal>
  )
}
